module.exports = __webpack_public_path__ + "res/ic_landscape_w.78ae94f05400028133ce800c9d353391.png";